import React, { useEffect, useState } from 'react';
import {useLoginBackgroundStyle} from '../utilities/loginBackground';
import { Link, useSearchParams } from 'react-router-dom';
import {useBrandLogo} from '../utilities/genreIcons';
import './LoginForm.css';
import { SIGNUP_ENABLED } from '../utilities/Constants';

const VerifyEmail = () => {
    const loginBgStyle = useLoginBackgroundStyle();
    const ddLogo = useBrandLogo();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading'); // loading | success | error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('No verification token found. Please use the link from your email.');
            return;
        }

        fetch(`${process.env.REACT_APP_API_PROXY}/auth/verify-email?token=${encodeURIComponent(token)}`)
            .then(async res => {
                const data = await res.json();
                if (res.ok) {
                    setStatus('success');
                    setMessage(data.message || 'Your email has been verified. You can now log in.');
                } else {
                    setStatus('error');
                    setMessage(data.message || 'Verification failed. The link may have expired.');
                }
            })
            .catch(() => {
                setStatus('error');
                setMessage('Could not reach the server. Please try again later.');
            });
    }, [searchParams]);

    return (
        <div className="login" style={loginBgStyle}>
            <div className="wrapper" style={{ textAlign: 'center' }}>
                <img src={ddLogo} alt="DD_Logo" className="brand-logo brand-logo--lg" />
                {status === 'loading' && (
                    <>
                        <h2 style={{ margin: '20px 0 10px', fontSize: '22px' }}>Verifying your email…</h2>
                        <p style={{ fontSize: '14px' }}>Please wait a moment.</p>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <h2 style={{ margin: '20px 0 10px', fontSize: '22px', color: 'var(--lm-tx-6fcf97)' }}>Email Verified!</h2>
                        <p style={{ fontSize: '14px', marginBottom: '24px', lineHeight: '1.6' }}>{message}</p>
                        <div className="register-link">
                            <p><Link to="/">Log in to DropWyrm</Link></p>
                        </div>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <h2 style={{ margin: '20px 0 10px', fontSize: '22px', color: '#eb5757' }}>Verification Failed</h2>
                        <p style={{ fontSize: '14px', marginBottom: '24px', lineHeight: '1.6' }}>{message}</p>
                        {SIGNUP_ENABLED && (
                            <div className="register-link">
                                <p>Need a new link? <Link to="/signup">Register again</Link></p>
                            </div>
                        )}
                    </>
                )}
            </div>
            <div className="copyright-footer">
                &copy; {new Date().getFullYear()} Virtual Realms Studios, LLC. All rights reserved.
            </div>
        </div>
    );
};

export default VerifyEmail;